import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MessageCircle } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { NAV, EMBEDS } from "../../i18n/content";

export function Footer() {
  const { t, pathFor } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t border-border bg-cream" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1fr]">
          <div>
            <p className="font-serif text-3xl text-charcoal">Shakti Love Music</p>
            <p className="mt-3 max-w-xs text-sm text-charcoal/60">{t("footer.tagline")}</p>
          </div>

          <div>
            <p className="mb-4 text-xs font-semibold uppercase tracking-overline text-terracotta">{t("footer.nav")}</p>
            <ul className="space-y-2">
              {NAV.map((item) => (
                <li key={item.path}>
                  <Link
                    to={pathFor(item.path)}
                    data-testid={`footer-nav-${item.key}`}
                    className="text-sm text-charcoal/70 transition-colors hover:text-terracotta"
                  >
                    {t(`nav.${item.key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="mb-4 text-xs font-semibold uppercase tracking-overline text-terracotta">{t("footer.social")}</p>
            <ul className="space-y-2">
              <li>
                <a href={EMBEDS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="inline-flex items-center gap-2 text-sm text-charcoal/70 transition-colors hover:text-terracotta">
                  <Instagram className="h-4 w-4" /> Instagram
                </a>
              </li>
              <li>
                <a href={EMBEDS.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="inline-flex items-center gap-2 text-sm text-charcoal/70 transition-colors hover:text-terracotta">
                  <Facebook className="h-4 w-4" /> Facebook
                </a>
              </li>
              <li>
                <a href={EMBEDS.soundcloudProfile} target="_blank" rel="noopener noreferrer" data-testid="footer-soundcloud" className="inline-flex items-center gap-2 text-sm text-charcoal/70 transition-colors hover:text-terracotta">
                  SoundCloud
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="mb-4 text-xs font-semibold uppercase tracking-overline text-terracotta">{t("footer.contact")}</p>
            <a href="mailto:info@francescadesalvia.com" data-testid="footer-email" className="inline-flex items-center gap-2 text-sm text-charcoal/70 transition-colors hover:text-terracotta">
              <Mail className="h-4 w-4 text-terracotta" />
              info@francescadesalvia.com
            </a>
            <a
              href="https://wa.me/34694461956"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="mt-3 inline-flex items-center gap-2 text-sm text-charcoal/70 transition-colors hover:text-terracotta"
            >
              <MessageCircle className="h-4 w-4 text-terracotta" />
              +34 694 46 19 56
            </a>
            <Link to={pathFor("/contact")} className="mt-4 block text-sm font-semibold text-terracotta" data-testid="footer-book-link">
              {t("cta.book")} →
            </Link>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-2 border-t border-border pt-8 text-xs text-charcoal/40 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} Shakti Love Music. {t("footer.rights")}</p>
          <p>{t("footer.built")}</p>
        </div>
      </div>
    </footer>
  );
}
